import axios from 'axios';


const api =  {
  get: async function(url, params={}){
    return await handleRequest(url, params, 'get')
  },
  delete: async function(url, params={}){
    return await handleRequest(url, params, 'delete')
  },
  post: async function(url, params={}){
    return await handleRequest(url, params, 'post')
  },
  patch: async function(url, params={}){
    return await handleRequest(url, params, 'patch')
  }
}

async function handleRequest(url, params, type){
  try {
    const tokenOk = await prepareToken()

    if(!tokenOk) window.logout()

    if(type === 'delete') params = {data: params}

    const response = await axios[type](url, params) 

    return response
  } catch(e){
    if(e.response.status === 401 && window.signed){
      window.logout && window.logout()
    }

    return e
  }
}

async function prepareToken(){
  let token = await localStorage.getItem('token')

  return !!token
}


export default api